import useWallet from '@plug-core/hooks/useWallet'
import { useDevMode } from '@plug-core/state'
import { openOnramper } from '@utils/onramper'
import { ROUTES } from '@utils/routes'
import React from 'react'
import { FiPlus } from 'react-icons/fi'
import { HiTrendingUp } from 'react-icons/hi'
import { HiArrowsUpDown } from 'react-icons/hi2'
import { IoIosSend } from 'react-icons/io'
import { TbCurrencyDollar } from 'react-icons/tb'
import { ActionButton, IActionButtonProps } from './ActionButton'

export const ActionButtons = () => {
  const { devEnabled } = useDevMode()
  const { wallet } = useWallet()

  const actions: IActionButtonProps[] = [
    {
      icon: FiPlus,
      label: 'Receive',
      route: ROUTES.ADDRESSES,
    },
    {
      icon: IoIosSend,
      label: 'Send',
      route: ROUTES.SEND,
    },
  ]

  const mainnetActions: IActionButtonProps[] = [
    {
      icon: HiArrowsUpDown,
      label: 'Swap',
      route: ROUTES.SWAP,
    },
    {
      icon: HiTrendingUp,
      label: 'DeFi',
      route: ROUTES.DEFI_HUB,
    },
  ]

  const buyButton = {
    icon: TbCurrencyDollar,
    label: 'Buy',
    onClick: () => openOnramper(wallet),
  }

  return (
    <div className="flex justify-between gap-4 px-2">
      {(devEnabled ? actions : [...actions, ...mainnetActions, buyButton]).map((action, index) => (
        <ActionButton key={index} {...action} />
      ))}
    </div>
  )
}
